// extracted by mini-css-extract-plugin
module.exports = {"root":"Informations_root__BstCF","col":"Informations_col__Vyo5f","listCol":"Informations_listCol__38BNt","itemCol":"Informations_itemCol__1xmTQ"};